import { IconArrowDown } from 'assets/DesignSystem/SVGComponents';
import { NudosButton } from 'components/NudosComponents';
import { useState } from 'react';
import CommentsBox from 'views/orders/Components/CommentsBox/CommentsBox';
import { useComments } from './hooks/useComments';
import { ICommentsAndObservations } from 'types/global';
import { IResponsibleUserData } from 'types/responsibleUser.types';
import { useOrganizationInfo } from './hooks/useOrganizationInfo';

import './OrderCommentsBox.scss';

interface IOrderCommentsBox {
  orderId?: number;
  logisticServiceId?: number;
  organizationId?: number;
  responsibleUsersList?: IResponsibleUserData[];
  onUploadComment: () => void;
}

export const OrderCommentsBox = ({
  orderId,
  logisticServiceId,
  organizationId,
  responsibleUsersList,
  onUploadComment
}: IOrderCommentsBox) => {
  const [isCommentsOpen, setIsCommentsOpen] = useState<boolean>(true);
  const { comments, isLoading, uploadComment } = useComments();
  const { organizationInfo } = useOrganizationInfo(organizationId);

  const toggleComments = () => {
    setIsCommentsOpen(prev => !prev);
  };

  const handleSubmit = async (comment: ICommentsAndObservations) => {
    if (!orderId && !logisticServiceId) return;

    const isSuccessful = await uploadComment({
      orderId,
      logisticServiceId,
      comment,
      assignedKamId: organizationInfo?.assignedKam?.id as number
    });

    if (isSuccessful) {
      onUploadComment();
    }
  };

  const canShowComments = isCommentsOpen && Boolean(organizationId);

  return (
    <div className="orderCommentsBox">
      <NudosButton
        customClassName="buttonComments"
        buttonText="Chat Interno"
        handleClick={toggleComments}
        buttonIcon={
          <div className="contentIcon">
            <IconArrowDown />
          </div>
        }
      />
      {canShowComments && (
        <CommentsBox
          closeComments={toggleComments}
          comments={comments || []}
          loading={isLoading}
          handleSubmitComments={handleSubmit}
          responsibleUsers={responsibleUsersList}
          organizationId={organizationId!}
        />
      )}
    </div>
  );
};
